<div class="d-flex align-items-start justify-content-center g-2">
  <ng-container *ngIf="currentQuestionIndex < gameDetails.Questions.length && !gameDetails.EntityGroupCompleted; else showResult">
    <ng-container *ngFor="let question of gameDetails.Questions; let i = index; trackBy: trackByFn">
      <div
        *ngIf="i === currentQuestionIndex"
        [ngClass]="{
          'game-question-card-fade-in': i === currentQuestionIndex && !isTransitioning,
          'game-question-card-slide-out ': isTransitioning,
        }"
        class="fgbcl-games-question-section"
      >
        <!-- Overlay when loading -->
        <div *ngIf="loadingState" class="fgbcl-game-overlay">
          <div class="spinner-border" style="width: 3rem; height: 3rem" role="status"></div>
        </div>

        <!-- Actual Question Content -->
        <ng-container *ngIf="gameDetails.Questions.length > 1">
          <div class="fgbcl-games-question-indicators-section">
            <div
              *ngFor="let questionStatus of questionStatuses; let i = index"
              class="fgbcl-games-attempted-question-indicators"
              [ngClass]="{
                'fgbcl-game-correct-answer-indicator': questionStatus == questionStatusType.Correct,
                'fgbcl-game-incorrect-answer-indicator': questionStatus == questionStatusType.Incorrect,
                'fgbcl-game-current-answer-indicator':
                  questionStatus == questionStatusType.NotStarted && i === currentQuestionIndex,
              }"
            >
              <ng-container *ngIf="questionStatus === questionStatusType.Correct">
                <span class="material-icons align-middle">done</span>
              </ng-container>
              <ng-container *ngIf="questionStatus === questionStatusType.Incorrect">
                <span class="material-icons">close</span>
              </ng-container>
            </div>
          </div>
        </ng-container>

        <fgbcl-games-question-item
          [question]="question"
          [currentQuestionIndex]="currentQuestionIndex"
          [groupId]="groupId"
          [groupType]="groupType"
          (answerSelected)="onAnswerSelected(i, $event)"
          [isExternal]="isExternal"
          (loadingState)="setLoadingState($event)"
        >
        </fgbcl-games-question-item>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #showResult>
    <div class="game-question-card-fade-in w-100">
      <fgbcl-game-result
        [gameDetails]="gameDetails"
        [showShareWithFriendButton]="true"
        [groupType]="groupType"
        [redirectPageURL]="sharedRedirectURL"
        (closeModal)="closeModalButton()"
        [isExternal]="isExternal"
      >
        <ng-container *ngIf="customContentTemplate">
          <ng-container *ngTemplateOutlet="customContentTemplate"></ng-container>
        </ng-container>
      </fgbcl-game-result>
    </div>
  </ng-template>
</div>
